import { Controller } from 'stimulus'
import throttle from '../utils/throttle'

// Distance from the top of the window when the animation triggers (in percent of window height)
const ANIMATION_OFFSET = 75
const ANIMATION_DELAY = 150 // in ms

export default class extends Controller {
  static targets = ['video']

  initialize() {
    this._handleScroll = throttle(this.handleScroll.bind(this), 100)
    if ('waitForImages' in this.element.dataset) {
      this.images = this.element.getElementsByTagName('img')
      this.imagesLoaded = 0
      Array.from(this.images).forEach(image => {
        if (image.complete) this.imageLoaded()
        else image.onload = () => this.imageLoaded()
      })
      if (this.images.length === 0) this.allImagesLoaded()
    } else {
      this.allImagesLoaded()
    }
  }

  handleScroll() {
    const position = this.element.getBoundingClientRect().top
    if (position > (ANIMATION_OFFSET / 100) * window.innerHeight) return
    // trigger animation once.
    const isTurbolinksPreview = document.documentElement.hasAttribute("data-turbolinks-preview")
    if (!isTurbolinksPreview) {
      this.element.classList.add('in-view')
    }
    this.unbindScroll()
    if (this.hasVideoTarget)
      setTimeout(() => this.videoTarget.play().catch(e => console.log('Animation failed to play:', e)), ANIMATION_DELAY) // Play the video once the in-view animation has time to complete.
  }

  unbindScroll() {
    window.removeEventListener('scroll', this._handleScroll)
  }

  allImagesLoaded() {
    // set up animation trigger
    window.addEventListener('scroll', this._handleScroll)
    this.handleScroll()
  }

  imageLoaded() {
    this.imagesLoaded++
    if (this.imagesLoaded >= this.images.length) this.allImagesLoaded()
  }

  restartVideo() {
    this.videoTarget.pause()
    this.videoTarget.currentTime = 0
    this.videoTarget.play().catch(e => console.log('Animation failed to play:', e))
  }

  connect() {
    if (this.hasVideoTarget) this.videoTarget.load() // preload video
    // Ensure the animation is undone before caching so it doesn't "jerk" when the page is re-visited
    document.addEventListener('turbolinks:before-cache', () => {
        this.element.classList.remove('in-view')
      }, {once: true}
    )
  }

  disconnect() {
    this.unbindScroll()
  }
}
